import { apiClient } from "./httpClient";
import { unwrapEnvelope, unwrapList, unwrapMeta } from "./response";

export const doctorsApi = {
  async list(params = {}) {
    const response = await apiClient.get("/doctors", { params });
    return {
      data: unwrapList(response.data),
      meta: unwrapMeta(response.data)
    };
  },

  async create(payload) {
    const response = await apiClient.post("/doctors", payload);
    return unwrapEnvelope(response.data, null);
  },

  async get(id) {
    const response = await apiClient.get(`/doctors/${id}`);
    return unwrapEnvelope(response.data, null);
  }
};
